import type { RootState } from '@/store';
import {
  Box,
  FormControlLabel,
  Paper,
  Switch,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';

import { toggleGuidedMode } from '@/store/slices/guidedModeSlice';

export const HelpModeToggle = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const dispatch = useDispatch();
  const guidedMode = useSelector((s: RootState) => s.guidedMode.guidedMode);

  return (
    <Tooltip title="Show page tips and short guidance for this screen." arrow>
      <Paper
        elevation={0}
        sx={{
          // Compact on phones, where it floats over the page content.
          px: isMobile ? 0.75 : 1.25,
          py: isMobile ? 0.25 : 0.5,
          display: 'flex',
          alignItems: 'center',
          borderRadius: 3,
          background: alpha(theme.palette.primary.main, 0.06),
          border: `1px solid ${alpha(theme.palette.primary.main, 0.18)}`,
          backdropFilter: 'blur(14px)',
          boxShadow: `0 4px 24px ${alpha(
            theme.palette.common.black,
            0.08
          )}, inset 0 1px 0 ${alpha(theme.palette.common.white, 0.85)}`,
        }}
      >
        <FormControlLabel
          control={
            <Switch
              size={isMobile ? 'small' : 'medium'}
              checked={guidedMode}
              onChange={() => dispatch(toggleGuidedMode())}
              color="primary"
            />
          }
          label={
            <Box sx={{ display: 'flex', flexDirection: 'column', mr: 0.5 }}>
              <Typography
                variant="caption"
                sx={{
                  fontWeight: 700,
                  lineHeight: 1.2,
                  color: theme.palette.text.primary,
                }}
              >
                Guided
              </Typography>
              {isMobile ? null : (
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: '0.65rem',
                    color: theme.palette.text.secondary,
                  }}
                >
                  help mode
                </Typography>
              )}
            </Box>
          }
          sx={{ m: 0, ml: 0.5 }}
        />
      </Paper>
    </Tooltip>
  );
};
